/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import { getUpdatedOptionsList } from "../../../../utils/optionsList";
import CheckBox from "../../../shared-ui/checkbox";
import InputField from "../../../shared-ui/input-field";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../../utils/userResponse";

// Interface Short Answer With None Component Props
interface ShortAnswerWithNoneComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  inputType?: string;
  inputPlaceHolder: string;
  errorMsg: any;
  whyQuestionList: [];
  listOfAnswers: any;
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
  dependent?: any;
  cmDependent: any;
}

// Interface Short Answer With None Component state
interface ShortAnswerWithNoneComponentState {
  inputValue: any;
  isEmptyValue: boolean;
  isSelectError?: boolean;
  isInputError?: boolean;
  inputErrorMessage?: string;
  errorMsg?: string;
  isPopupOpen: boolean;
  isInputVisible: boolean;
  optionsList: any;
  questionTitleState?: string;
}

/**
 * Used for any answer type is in a single line.
 *
 * @namespace ShortAnswerComponent
 */

class ShortAnswerWithNoneComponent extends React.Component<
  ShortAnswerWithNoneComponentProps,
  ShortAnswerWithNoneComponentState
> {
  constructor(props: ShortAnswerWithNoneComponentProps) {
    super(props);
    this.state = {
      inputValue: "",
      isEmptyValue: false,
      isInputError: false,
      isSelectError: false,
      inputErrorMessage: "",
      isPopupOpen: false,
      isInputVisible: false,
      optionsList: [],
    };
  }

  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setPreFillData(recoValuesData);
    } else {
      const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
      data.forEach(function (item: {
        isChecked: boolean;
        isDisabled: boolean;
      }) {
        item.isChecked = false;
        item.isDisabled = false;
      });
      this.setState({
        optionsList: data,
        questionTitleState: this.props.questionTitle,
      });
    }
  };

  // componentDidUpdate = () => {
  //   const { listOfAnswers } = this.props;
  //   const { optionsList } = this.state;
  //   const data: any = getUpdatedOptionsList(listOfAnswers);
  //   data.forEach(function (item: { isChecked: boolean; isDisabled: boolean }) {
  //     item.isChecked = false;
  //     item.isDisabled = false;
  //   });
  //   /*This code will be required if checkbox state has to retained after language change*/
  //   //const updatedOptions=_.omit(optionsList,['value']);
  //   //let result = _.values(_.merge(_.keyBy(updatedOptions, 'id'), _.keyBy(data, 'id')));
  //   //const equal=_.isEqual(result,optionsList);
  //   let listOfAnswersProps = data.map(function (element: any) {
  //     return element.value;
  //   });
  //   let listOfAnswersState = optionsList.map(function (element: any) {
  //     return element.value;
  //   });
  //   const equal = _.isEqual(listOfAnswersProps, listOfAnswersState);
  //   if (!equal) {
  //     //this.setState({optionsList:result});
  //     this.setState({
  //       optionsList: data,
  //       isInputError: false,
  //       isInputVisible: false,
  //       isSelectError: false,
  //     });
  //   }
  // };

  componentDidUpdate = () => {
    const { listOfAnswers } = this.props;
    let data: any = getUpdatedOptionsList(listOfAnswers);
    data.forEach(function (item: { isChecked: boolean }) {
      item.isChecked = false;
    });
    if (this.props.questionTitle !== this.state.questionTitleState) {
      this.setState({
        optionsList: data,
        isInputError: false,
        isInputVisible: false,
        isSelectError: false,
        questionTitleState: this.props.questionTitle,
      });
      let recoValuesData: any = getPreFillDataByContentKey(
        this.props.contentTypeId
      );
      if (recoValuesData) {
        this.setPreFillData(recoValuesData);
      }
    }
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoValuesData: any) => {
    let inputValueText: string = "";
    let inputVisible: boolean = false;
    let isNone: boolean = false;
    let recoValuesLength: any = recoValuesData?.values?.length;
    const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
    _.map(data, (item: any, index: any) => {
      if (_.includes(recoValuesData.recoValues, item.id)) {
        item.isChecked = true;
        if (index === data?.length - 2) {
          inputVisible = true;
          inputValueText = recoValuesData?.values[recoValuesLength - 1];
        }
        if (index === data?.length - 1) {
          isNone = true;
        }
      } else {
        item.isChecked = false;
      }
      if (index === data?.length - 1) {
        if (inputVisible) {
          item.isDisabled = true;
        } else if (isNone) {
          data.forEach(function (item: any, index: Number) {
            item.isChecked = data.length - 1 === index ? true : false;
            item.isDisabled = data.length - 1 === index ? false : true;
            inputVisible = false;
          });
        } else {
          item.isChecked = false;
          item.isDisabled = true;
        }
      }
    });
    this.setState({
      optionsList: data,
      isInputError: false,
      isInputVisible: inputVisible,
      isSelectError: false,
      inputValue: inputValueText,
    });
  };

  /**
   * This method is used for handling error
   *
   *
   */
  handleError = () => {
    const { optionsList } = this.state;
    const { errorMsg } = this.props;
    let isError = false;
    const filteredOptions = optionsList.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    if (filteredOptions === optionsList.length) {
      isError = true;
      this.setState({
        isSelectError: true,
      });
    }
    if (this.state.isInputVisible) {
      if (this.state.inputValue.length === Number(errorMsg.char_min_limit[0])) {
        isError = true;
        this.setState({
          isInputError: true,
          inputErrorMessage: errorMsg.char_min_limit[1],
        });
      }

      if (this.state.inputValue.length > Number(errorMsg.char_max_limit[0])) {
        isError = true;
        this.setState({
          isInputError: true,
          inputErrorMessage: errorMsg.char_max_limit[1],
        });
      }
    }
    if (isError === false) {
      this.setState(
        {
          isInputError: false,
          isSelectError: false,
        },
        () => {
          if (this.props.dependent || this.props.cmDependent) {
            const data: any = this.getSelectedData();
            /*if strict checking of values is required
             let isValueFound = _.isEqual(conditions, selectedValue);
             */
            if (this.props.cmDependent && this.props.dependent) {
              const { conditions, dependent_content_type_id } = this.props.dependent;
              const selectedValues = data.recoValues;
              let newArray = _.intersection(conditions, selectedValues);
              let isValueFound: boolean = newArray.length > 0 ? true : false;

              const addRemoveData = this.handleAddRemoveCm();
              if (isValueFound) {
                addRemoveData.valuesToRemove = _.union(dependent_content_type_id, addRemoveData.valuesToRemove);
              } else {
                addRemoveData.valuesToAdd = _.union(dependent_content_type_id, addRemoveData.valuesToAdd);
              }

              this.props.handleSuccessfulContinue(
                false,
                false,
                false,
                false,
                true,
                addRemoveData.valuesToAdd,
                addRemoveData.valuesToRemove,
              );
            } else {
              if (this.props.dependent) {
                const { conditions, dependent_content_type_id } = this.props.dependent;
                const selectedValues = data.recoValues;
                let newArray = _.intersection(conditions, selectedValues);
                let isValueFound: boolean = newArray.length > 0 ? true : false;
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  dependent_content_type_id,
                  isValueFound,
                  false,
                  false,
                  false
                );
              }
              if (this.props.cmDependent) {
                const addRemoveData = this.handleAddRemoveCm();
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  false,
                  false,
                  true,
                  addRemoveData.valuesToAdd,
                  addRemoveData.valuesToRemove,
                );
              }
            }
          } else {
            this.getSelectedData();
            this.props.handleSuccessfulContinue();
          }
        }
      );
    }
  };

  /**
   * 
   * handleAddRemoveCm -- data to remove or add
   */
  handleAddRemoveCm = () => {
    const cmDepList: any = this.props.cmDependent;
    const data: any = this.getSelectedData();
    const selectedValue = data?.recoValues;
    let valuesToAdd: any = [];
    let valuesToRemove: any = [];
    _.map(cmDepList, (eachData: any) => {
      if (!_.isEmpty(eachData)) {
        let newArray = _.intersection(eachData.conditions, selectedValue);
        let isCmValueFound: boolean = newArray.length > 0 ? true : false;
        if (isCmValueFound) {
          valuesToRemove.push(...eachData.dependent_content_type_id);
        } else {
          valuesToAdd.push(...eachData.dependent_content_type_id);
        }
      }
    })
    let cmData: any = {
      valuesToAdd: valuesToAdd,
      valuesToRemove: valuesToRemove
    }
    return cmData;
  }


  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData: Object = {};
    let recoValue: Array<String> = [];
    let values: Array<String> = [];
    if (!_.isEmpty(this.state.optionsList)) {
      _.map(this.state.optionsList, (data: any, index: any) => {
        if (data?.isChecked) {
          recoValue.push(data.id);
          if (index == this.state.optionsList.length - 2) {
            values.push(this.state.inputValue);
          } else {
            values.push(data.value);
          }
        }
      });
    }
    responseData = {
      contentTypeId: this.props.contentTypeId,
      recoId: this.props.recoId,
      recoValues: recoValue,
      values: values,
    };
    setUserResponse(responseData);
    return responseData;
  };

  /**
   * This method is used for handle input change
   * @param {Object} evt
   *
   */

  handleInputChange = (evt: any) => {
    const capitalizedValue = evt.target.value.substr(0, 1).toUpperCase() + evt.target.value.substr(1);
    this.setState({
      inputValue: capitalizedValue,
      isInputError: false,
    });
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle Why Asking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };
  handleCheckbox = (value: string, index: number, evt?: any) => {
    evt?.stopPropagation();
    if (evt && evt.charCode === 32) {
      return;
    }
    const { optionsList } = this.state;
    //const isChecked = evt.target.checked;
    const data: any = optionsList;
    // const objIndex = data.findIndex((obj: any) => obj.value === value);
    data[index].isChecked = !data[index].isChecked;
    const otherReason = data.filter((obj: any) => obj.isVisible === "true");

    if (otherReason[0]?.isChecked === true) {
      this.setState({
        isInputVisible: true,
      });
    } else {
      this.setState({
        isInputVisible: false,
        isInputError: false,
        inputValue: "",
      });
    }

    /*This code is used to handle disabling of options*/
    const uncheckedFilteredOptions = this.state.optionsList.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    const allExceptNoneOptions = _.initial(data);
    const checkedFilteredOptions = allExceptNoneOptions.filter(
      (obj: any) => obj.isChecked === true
    ).length;
    if (index === optionsList.length - 1 && data[optionsList.length - 1]) {
      for (let i = 0; i < data.length - 1; i = i + 1) {
        data[i].isDisabled = true;
      }
    }
    if (checkedFilteredOptions > 0) {
      data[optionsList.length - 1].isDisabled = true;
    }
    if (uncheckedFilteredOptions === this.state.optionsList.length) {
      data.forEach((element: any) => {
        element.isDisabled = false;
      });
    }

    if (uncheckedFilteredOptions !== this.state.optionsList.length) {
      this.setState({
        isSelectError: false,
      });
    }

    this.setState({ optionsList: data });
  };
  render() {
    const {
      questionTitle,
      questionSubTitle,
      inputType,
      inputPlaceHolder,
      whyQuestionList,
      errorMsg,
    } = this.props;
    const {
      inputValue,
      isInputVisible,
      isInputError,
      inputErrorMessage,
      isSelectError,
      optionsList,
    } = this.state;

    return (
      <>
        <div className="inner-wrapper short-answer-container">
          <WhyAskingPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            list={whyQuestionList}
          />

          <div className="question-wrappper">
            <div className="question-label">{questionTitle || ""}</div>
            <div className="question-sub-label">{questionSubTitle || ""}</div>
          </div>

          {/* Short Answer inner wrapper Start */}
          <div className="short-answer-wrapper">
            <div className="answer-list-conatiner">
              <div className="checkbox-container">
                {optionsList && optionsList.length > 0
                  ? optionsList.map((item: any, index: any) => (
                    <div
                      key={index}
                      tabIndex={0}
                      role="checkbox"
                      className={
                        item && item.isDisabled
                          ? "checkbox-wrapper disable"
                          : item && item.isChecked
                            ? item.isVisible === "true"
                              ? "checkbox-wrapper with-input active"
                              : "checkbox-wrapper active"
                            : isSelectError
                              ? "checkbox-wrapper checkbox-error"
                              : "checkbox-wrapper"
                      }
                      onClick={() => this.handleCheckbox(item.value, index)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleCheckbox(item.value, index, e);
                        }
                      }}
                    >
                      <CheckBox
                        className={
                          "checkbox"
                          // isSelectError
                          //   ? "checkbox checkbox-error"
                          //   : "checkbox"
                        }
                        onCheckboxClick={(evt) =>
                          this.handleCheckbox(item.value, index, evt)
                        }
                        isChecked={item && item.isChecked}
                      />
                      <div
                        className={
                          item && item.isChecked
                            ? "list-label active"
                            : "list-label"
                        }
                      >
                        {item.value || ""}
                      </div>
                      {item && item.isChecked && item.isVisible === "true" ? (
                        <div className="input-container">
                          <InputField
                            type={inputType || "text"}
                            placeHolder={inputPlaceHolder}
                            className={
                              // "custom-input"
                              isInputError
                                ? "custom-input error-input no-caplitalize"
                                : "custom-input no-caplitalize"
                            }
                            //name="weightInputValue"
                            handleInputChange={(e: any) => {
                              this.handleInputChange(e);
                            }}
                            isError={isInputError}
                            inputValue={inputValue || ""}
                            errorMsg={inputErrorMessage}
                            handleInputclick={(e) => {
                              e.stopPropagation();
                            }}
                            autoFocusOnInput
                          />
                        </div>
                      ) : null}
                    </div>
                  ))
                  : null}
              </div>
            </div>
            <div tabIndex={0} className={isSelectError ? "error-msg" : "hide"}>
              {errorMsg && errorMsg.empty_error}
            </div>
          </div>
          {/* Short Answer inner wrapper Ends */}

          {whyQuestionList && whyQuestionList.length > 0 ? (
            <WhyAskingComponent
              {...this.props}
              handlePopup={this.handlePopup}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default ShortAnswerWithNoneComponent;
